import { CustomerInfo, OfflineMessageResponse } from '../OfflineMessage/OfflineMessageResponse';

export interface ConversationAndOfflineMessagesResponse {
  Conversation: PreviousConversationHistoryResponse;
  OfflineMessages: Array<OfflineMessageResponse>;
}

interface PreviousConversationHistoryResponse {
  Id: string;
  AccountSid: string;
  CurrentConversationSid: string;
  ConversationSids: Array<string>;
  FriendlyName: string;
  UniqueName: string;
  NickName: string;
  VisitorId: string;
  CampaignId: string;
  SiteId: string;
  CampaignName: string;
  HasRated: boolean;
  FirstResponseTime: number;
  DateClosed: Date;
  ClosedBy: ConversationCloseBy;
  Disposition: Disposition;
  Note: Note;
  CurrentStatus: ConversationStatus;
  Statuses: Array<ConversationStatusRecord>;
  Direction: Direction;
  ChannelType: ParticipantChannelType;
  LastMessage: LastMessage;
  CustomerInfo: CustomerInfo;
  CurrentAssignee: CurrentAssignee;
  Transfers: Array<CurrentAssignee>;
  Participants: Array<Participant>;
  PreviousChatHistory: Array<HistoryDto>;
}

export interface HistoryDto {
  ConversationId: string;
  ConversationSid: string;
  FriendlyName: string;
  NickName: string;
  ConversationType: ConversationType;
  CreatedOn: Date;
  AgentInfo: VisitorAgentInfo;
  VisitorId: string;
}
export interface VisitorAgentInfo {
  UserId: string;
  Email: string;
  Name: string;
  DateCreated: Date;
}
export enum ConversationCloseBy {
  System,
  Customer,
  Agent,
}

export interface Disposition {
  Id: string;
  Name: string;
}
export interface Note {
  Title: string;
  Name: string;
}
export enum ConversationStatus {
  Open,
  Close,
}
export enum Direction {
  Inbound,
  Outbound,
}

export interface ConversationStatusRecord {
  Status: ConversationStatus;
  DateCreated: Date;
}

export enum ParticipantChannelType {
  Web,
  SMS,
  WhatsApp,
  Messenger,
  Instagram,
  All,
}

export interface LastMessage {
  Body: string;
  DateCreated: Date;
  MessageSid: string;
}

export interface CurrentAssignee {
  Id: string;
  UserId: string;
  IbexId: string;
  SessionId: string;
  Email: string;
  Name: string;
  PseudoName: string;
  DateCreated: Date;
  ParticipantType: UserType;
}
export enum UserType {
  Customer,
  Agent,
  Supervisor,
  Admin,
  Bot,
}

export interface Participant {
  UserId: string;
  Type: UserType;
  PhoneNumber: string;
  ChannelType: ParticipantChannelType;
  DateCreated: Date;
}

export enum ConversationType {
  General,
  Customer,
  Agent,
}
export enum MessageType {
  Customer,
  Agent,
  Supervisor,
  Admin,
  Bot,
}
export enum DeliveryReceiptsEnum {
  Delivered,
  Failed,
  Read,
  Sent,
  Undelivered,
}
